import React from 'react';
import { Box, BoxProps } from '../box/box';
import { Button } from '../button/button';
import { DialogActionButtonConfig } from './dialog-action-button-config';

interface DialogActionsProps {
  actions: DialogActionButtonConfig[];
  onClose: () => void;
  centered?: boolean;
  containerProps?: BoxProps;
}

export function DialogActions({ actions = [], onClose, centered, containerProps }: DialogActionsProps) {
  return (
    <Box
      flexDirection={['column', 'row']}
      justifyContent={centered ? 'center' : 'end'}
      gridGap={3}
      mt={3}
      px={3}
      pb={3}
      {...containerProps}
    >
      {actions.map((action) => {
        const { label, type = 'primary', buttonProps, ...rest } = action;

        return (
          <Button
            key={label}
            onClick={action.onClick || onClose}
            color={type}
            type={buttonProps?.type ?? 'button'}
            appearance={buttonProps?.appearance ?? (type === 'secondary' ? 'outlined' : 'filled')}
            size={buttonProps?.size ?? 'lg'}
            shape={buttonProps?.shape ?? 'rectangle'}
            disabled={action.disabled}
            isLoading={action.isLoading}
            {...rest}
          >
            {label}
          </Button>
        );
      })}
    </Box>
  );
}
